import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import {
  coresTextosGlobais, tamanhosControlesGlobais,
  tamanhosPaginasAdministrativas,
} from "../../estilos/global";

// O destino pertence à página: inclusive os bloqueios de formulários em envio.
export function BotaoVoltar({
  onClick,
  rotulo = "Voltar",
  disabled = false,
  acompanharAltura = false,
}) {
  return (
    <Tooltip title={rotulo} arrow>
      <Box component="span" sx={{ display: "inline-flex", flexShrink: 0, alignSelf: acompanharAltura ? "stretch" : undefined }}>
        <IconButton
          type="button"
          aria-label={rotulo}
          onClick={onClick}
          disabled={disabled || !onClick}
          sx={{
            width: 44,
            height: acompanharAltura ? "auto" : 44,
            minHeight: 44,
            borderRadius: 1.5,
            bgcolor: "var(--sear-superficie-azul, #e8f4ff)",
            color: "var(--sear-azul, #087cf0)",
            "&:hover": { bgcolor: "var(--sear-superficie-azul, #d9edff)" },
            "&.Mui-focusVisible": {
              outline: "2px solid var(--sear-borda-forte, #087cf0)",
              outlineOffset: 2,
            },
          }}
        >
          <ArrowBackRoundedIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

export default function CabecalhoPaginaSecundaria({
  titulo,
  descricao,
  onVoltar,
  rotuloVoltar = "Voltar",
  desabilitarVoltar = false,
  acoes,
  sx,
}) {
  return (
    <Box
      component="header"
      sx={[
        {
          display: "flex",
          alignItems: { xs: "stretch", md: "center" },
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          gap: 1.5,
          mb: 1.5,
          minWidth: 0,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ display: "flex", alignItems: descricao ? "stretch" : "center", gap: 1.4, minWidth: 0 }}>
        <BotaoVoltar
          acompanharAltura={Boolean(descricao)}
          onClick={onVoltar}
          rotulo={rotuloVoltar}
          disabled={desabilitarVoltar}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: tamanhosPaginasAdministrativas.tituloPagina,
              fontWeight: 700,
              color: coresTextosGlobais.tituloPagina,
              lineHeight: 1.15,
              overflowWrap: "anywhere",
            }}
          >
            {titulo}
          </Typography>
          {descricao && (
            <Typography
              sx={{
                mt: 0.35,
                fontSize: tamanhosControlesGlobais.descricao,
                lineHeight: 1.35,
                color: "var(--sear-texto-secundario, #7b8798)",
              }}
            >
              {descricao}
            </Typography>
          )}
        </Box>
      </Box>
      {acoes && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            minWidth: 0,
            "& > .MuiBox-root": { flexWrap: "wrap", maxWidth: "100%" },
          }}
        >
          {acoes}
        </Box>
      )}
    </Box>
  );
}
